import * as React from "react";

import "./SassDocContent.scss";

import { ApiProperty, ApiType } from "./ComponentApiType";

import { currentUserTheme, getThemeValues } from "../theming";

import { expandThemeableProperties } from "azure-devops-ui/Core/Util/Theming";
import { Observer } from "azure-devops-ui/Observer";

// // tslint:disable-next-line:no-var-requires
// const json = require("!raw-loader!azure-devops-ui/sassdoc.json");
import sassDocs from "../_Generated/sassDocs";

export interface ISassDocContentProps {
    groups: string[];
}

interface ISassDocs {
    [topLevelGroup: string]: ISassDocGroup[];
}

interface ISassDocGroup {
    groupName: string;
    items: ISassDocItem[];
}

interface ISassDocItem {
    name: string;
    description: string;
    value?: string;
}

export default class SassDocContent extends React.Component<ISassDocContentProps> {
    public render(): JSX.Element {
        const sassDocItems = sassDocs as ISassDocs;
        const subGroups: ISassDocGroup[] = [];

        for (const group of this.props.groups) {
            subGroups.push(...sassDocItems[group]);
        }

        return (
            <Observer theme={currentUserTheme}>
                {(props: { theme: string }) => {
                    const themeValues = getThemeValues();
                    return (
                        <div className="component-api-content">
                            {subGroups.map((subGroup, index) => {
                                return (
                                    <ApiType key={index} typeName={subGroup.groupName}>
                                        {subGroup.items.map((item, itemIndex) => {
                                            let value: string | undefined;
                                            let isColor = false;
                                            if (item.value) {
                                                value = expandThemeableProperties(item.value.replace(/rgbcolor\(/g, "rgba("), themeValues);
                                                isColor = value.startsWith("rgba(");
                                            }

                                            const property = (
                                                <ApiProperty
                                                    key={itemIndex}
                                                    typeName={subGroup.groupName}
                                                    name={item.name}
                                                    description={item.description}
                                                    propertyTypes={value ? [value] : undefined}
                                                />
                                            );

                                            if (isColor) {
                                                return (
                                                    <div className="flex-row">
                                                        <div className="sassdoc-color-cell-container themed flex-row">
                                                            <div className="sassdoc-color-cell flex-grow" style={{ backgroundColor: value }} />
                                                        </div>
                                                        {property}
                                                    </div>
                                                );
                                            } else {
                                                return property;
                                            }
                                        })}
                                    </ApiType>
                                );
                            })}
                        </div>
                    );
                }}
            </Observer>
        );
    }
}
